import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCustomNavigate } from '../../../../utils/customHooks/useCustomNavigate';

export default function SuccessOperation() {
  const { t } = useTranslation('salary-card');
  const navigate = useCustomNavigate();

  return (
    <>
      <Box
        width={'100%'}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        sx={{ px: { xs: 2, sm: 3 } }}
      >
        <img
          src='/images/digital_account/completed_icon.png'
          alt='non working hour'
          width={64}
          height={64}
        />
        <Box
          textAlign={'center'}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          gap={1}
          mt={{ xs: 3, sm: 4 }}
          sx={{ width: '100%', maxWidth: 580 }}
        >
          <Typography
            lineHeight={1.5}
            fontWeight={'bold'}
            align='center'
            sx={{ fontSize: { xs: 20, sm: 24, md: 28 }, wordBreak: 'break-word' }}
          >
            {t('success.title')}
          </Typography>
          <Typography lineHeight={1.5} align='center' sx={{ fontSize: { xs: 14, sm: 16 } }}>
            {t('success.description')}
          </Typography>
          <Typography sx={{ fontSize: { xs: 14, sm: 16 } }} align='center'>
            {t('success.statusPrefix')}{' '}
            <Typography component={'b'} fontWeight={700} sx={{ fontSize: { xs: 14, sm: 16 } }}>
              {t('success.statusPath')}{' '}
            </Typography>
            {t('success.statusSuffix')}
          </Typography>
        </Box>
      </Box>
      <Box
        display={'flex'}
        gap={{ xs: 1, sm: 1 }}
        justifyContent={'center'}
        sx={{
          px: { xs: 2, sm: 3 },
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
        }}
      >
        <Button
          onClick={() => navigate('salary-card/applications')}
          color='secondary'
          sx={{
            mt: 3,
            height: 56,
            width: { xs: '100%', sm: 277 },
            maxWidth: 360,
          }}
        >
          {t('success.viewStatus')}
        </Button>
        <Button
          onClick={() => navigate('home-page')}
          sx={{
            mt: { xs: 1, sm: 3 },
            height: 56,
            width: { xs: '100%', sm: 277 },
            maxWidth: 360,
          }}
        >
          {t('success.goHome')}
        </Button>
      </Box>
    </>
  );
}
